import Icon from "@ant-design/icons";
import React from "react";
import ArrowLeft from "./components/ArrowLeft";
import ArrowRight from "./components/ArrowRight";
import Close from "./components/Close";
import TreeNext from "./components/TreeNext";
import TreeNode from "./components/TreeNode";

const svgs = {
  ArrowLeft,
  ArrowRight,
  Close,
  TreeNext,
  TreeNode,
};

type IconName = keyof typeof svgs;

interface SvgIconProps
  extends Omit<React.ComponentProps<typeof Icon>, "component"> {
  component: IconName;
}

const SvgIcon: React.FC<SvgIconProps> = ({ component, ...others }) => {
  return <Icon component={svgs[component]} {...others} />;
};

export default SvgIcon;
